import Hero from "../components/Hero";
import Manifesto from "../components/Manifesto";
import MuralMosaic from "../components/MuralMosaic";
import Process from "../components/Process";
import Artists from "../components/Artists";
import Testimonials from "../components/Testimonials";
import CallToAction from "../components/CallToAction";
import PartnerMarquee from "../components/PartnerMarquee";

export default function HomePage() {
  return (
    <main className="bg-[var(--bg)] text-[var(--bone)]">
      <Hero />
      <Manifesto />
      <MuralMosaic />
      <Process />
      <PartnerMarquee />
      <Artists />
      <Testimonials />
      <CallToAction />
    </main>
  );
}